// Approximate visual packing guide only. Shopify remains the authority for prices and discounts.
(() => {
  const kinds={
    'switch-witch-the-missing-map':'book','2026-variety-pack':'main','variety-pack-v2':'main','2026-variety-pack-v2':'main','all-chocolate-box':'main','fruity-swedish-no-chocolate':'main',
    'neighborhood-party-pack':'neighborhood','swedish-candy-sampler-2-lbs':'main','halloween-favors-10-pack':'halloween','chocolate-lovers-sweets-18-piece':'candy','chocolate-lovers-add-on-v2':'candy','swedish-candy-mix-8-oz':'candy',
    '8302578761846':'main','9046770647158':'main','9069692158070':'main','8302689091702':'main','8302699217014':'main','8302480818294':'neighborhood',
    '9082218348662':'main','9082219921526':'halloween','8302479179894':'candy','9046928916598':'candy','8302479933558':'candy','8302480326774':'book'
  };
  const sizes=[
    {label:'Small',cap:4.25,visualCap:4,maxMain:1,maxCandy:2,maxBook:1},
    {label:'Medium',cap:7,maxMain:2},
    {label:'Large',cap:11,maxMain:4},
    {label:'Extra-large',cap:15,maxMain:6}
  ];
  const unitsOf=q=>13.5*(q.neighborhood||0)+4.25*(q.halloween||0)+2*q.main+q.candy+q.book*.25;
  function fits(q,size){
    return unitsOf(q)<=size.cap&&q.main<=size.maxMain&&q.candy<=(size.maxCandy??Infinity)&&q.book<=(size.maxBook??Infinity);
  }
  function estimate(items){
    let main=0,candy=0,book=0,neighborhood=0,halloween=0,unknown=false;
    for(const item of items){
      const n=Number(item.quantity)||0;if(n<=0)continue;
      if(!Number.isSafeInteger(n)){unknown=true;continue;}
      const kind=kinds[String(item.product_id)]||kinds[item.handle];
      if(kind==='main')main+=n;else if(kind==='halloween')halloween+=n;else if(kind==='candy')candy+=n;else if(kind==='book')book+=n;else if(kind==='neighborhood')neighborhood+=n;else unknown=true;
    }
    if(unknown||!Number.isSafeInteger(main+candy+book+neighborhood+halloween))return {label:'Packing estimate needed',full:null,boxes:[],count:0};
    const boxes=[];
    const remaining={main,candy,book,halloween};
    function addBox(size,contents,count=1){
      const full=Math.min(100,Math.round(unitsOf(contents)/(size.visualCap||size.cap)*100));
      const prior=boxes[boxes.length-1];
      if(prior&&prior.label===size.label&&JSON.stringify(prior.contents)===JSON.stringify(contents))prior.count+=count;
      else boxes.push({label:size.label,count,full,contents});
    }
    // Keep one Neighborhood per XL, using its estimated 10% spare room for
    // whole add-ons/books. Do not pool spare space across boxes to fit a pack.
    let neighborhoodBoxes=neighborhood;
    while(neighborhoodBoxes>0){
      const contents={neighborhood:1,main:0,candy:Math.min(remaining.candy,1),book:0};
      contents.book=Math.min(remaining.book,(1.5-contents.candy)*4);
      const repeats=Math.min(neighborhoodBoxes,...['candy','book'].filter(k=>contents[k]>0).map(k=>Math.floor(remaining[k]/contents[k])));
      addBox(sizes[3],contents,repeats);
      remaining.candy-=contents.candy*repeats;
      remaining.book-=contents.book*repeats;
      neighborhoodBoxes-=repeats;
    }
    while(unitsOf(remaining)>0){
      const size=sizes.find(s=>fits(remaining,s));
      if(size){addBox(size,{...remaining});break;}
      // Fill an XL without splitting a pack, then cascade the remainder.
      const contents={halloween:Math.min(3,remaining.halloween),main:0,candy:0,book:0};
      let space=15-4.25*contents.halloween;
      contents.main=Math.min(remaining.main,Math.floor(space/2),6);space-=2*contents.main;
      contents.candy=Math.min(remaining.candy,Math.floor(space));space-=contents.candy;
      contents.book=Math.min(remaining.book,Math.floor(space*4));
      // Group repeated boxes efficiently, including very large quantities.
      const repeats=Math.min(...Object.keys(contents).filter(k=>contents[k]>0).map(k=>Math.floor(remaining[k]/contents[k])));
      addBox(sizes[3],contents,repeats);
      for(const k of Object.keys(remaining))remaining[k]-=contents[k]*repeats;
    }
    const count=boxes.reduce((sum,b)=>sum+b.count,0);
    return {label:count===0?'Your box':count===1?boxes[0].label+' box':`${count} boxes`,full:count===1?boxes[0].full:count===0?0:null,boxes,count};
  }
  function render(target,items){
    if(!target)return;
    const result=estimate(items);
    target.replaceChildren();
    const title=document.createElement('div');title.className='tbtt-box-meter__title';
    const totals=new Map();
    for(const box of result.boxes)totals.set(box.label,(totals.get(box.label)||0)+box.count);
    const shortNames={Small:'S',Medium:'M',Large:'L','Extra-large':'XL'};
    const combination=[...totals].map(([name,count])=>count>1?`${count}${shortNames[name]}`:shortNames[name]).join(' + ');
    title.textContent=result.count?`Estimated packing · ${result.count} ${result.count===1?'box':'boxes'}${result.count>1?' · '+combination:''}`:result.label;target.append(title);
    // Only the last box is the active meter, even when earlier boxes remain in the order.
    const box=result.boxes[result.boxes.length-1];
    if(box){
      const label=document.createElement('div');label.className='tbtt-box-meter__label';
      const name=document.createElement('span');name.textContent=box.label+' box';
      const hint=document.createElement('span');
      hint.textContent=box.full===100?'Full estimate':`About ${100-box.full}% room left`;
      label.append(name,hint);target.append(label);
      const track=document.createElement('div');track.className='tbtt-box-meter__track';
      track.setAttribute('role','progressbar');track.setAttribute('aria-label',`${result.count>1?'Last box: ':''}${box.label} box estimated fullness`);track.setAttribute('aria-valuemin','0');track.setAttribute('aria-valuemax','100');track.setAttribute('aria-valuenow',String(box.full));
      const fill=document.createElement('span');fill.style.width=box.full+'%';track.append(fill);target.append(track);
    }
    if(result.count){const note=document.createElement('p');note.className='tbtt-box-meter__note';note.textContent='Approximate packing. Shipping included; final packing may vary.';target.append(note);}
  }
  window.tbttBoxMeter={render,estimate};
  function start(){
    const cart=document.querySelector('cart-items');if(!cart)return;
    function refresh(){

      const items=[...cart.querySelectorAll('.cart-item')].map(row=>{
        const link=row.querySelector('.cart-item__name[href]');
        const handle=link?new URL(link.href,location.origin).pathname.split('/products/')[1]?.split('/')[0]:'';
        return {handle,quantity:row.querySelector('input[name="updates[]"]')?.value||0};
      });
      render(document.querySelector('[data-cart-box-meter]'),items);
    }
    new MutationObserver(refresh).observe(cart,{childList:true,subtree:true});
    window.addEventListener('pageshow',refresh);refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
